import { SetCookie, GetCookie } from './cookies';
import { isPro, isBasic, isAuthV1Paid, isAdvanced } from './auth';
import axios from 'axios';


var totalApps = 0;
const requestOptions = {
  method: "POST",
  mode: "cors",
};
const strUrl = `${process.env.REACT_APP_BTUTIL_API_URL}e/get-total-app`;

fetch(strUrl, requestOptions)
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    totalApps = data.total;
  })
  .catch((error) => {});


export const returnAppHref = (auth, url) => {
  if(!auth) {
    return url;
  }
  // for unpaid user
  if(auth.status === 'pending') {
    if(
      url.includes('storybook')
      || url.includes('teacher.ai')
      || url.includes('chat.ai')
      || url.includes('chatpro.ai')
      || url.includes('chatpdf.ai')
      || url.includes('search')
      || url.includes('dream-photo')
      || url.includes('chatlibrary')
      || url.includes('start-chatbot')
      || url.includes('text-to-image')
      || url.includes('convert-to-proper-english')
      || url.includes('interior')
      || url.includes('restorephoto')
      || url.includes('chatgpt')
      || url.includes('multillm')
      || url.includes('coding')
      || url.includes('avatarmaker')
      || url.includes('tutor')
      || url.includes('flux')
    ) {
      return url;
    }
    if(url.includes('dream-photo')){
      return "javascript:void(0)";
    }
  }
  if(checkRestrictPlan(auth, url)) {
    return "javascript:void(0)";
  }
  if(url.includes('flux') && auth.expired === 'no') {
    return url;
  }
  if(isAdvanced(auth)) return url;
  // for v1 user
  if( isAuthV1Paid(auth)
  || url.includes('chat.ai')
  || isPro(auth)) {
    return url;
  }
  // for basic user
  if( isBasic(auth)
  && ( url.includes('chatbot') || url.includes('create-art') || url.includes('dream-photo') || url.includes('chatgpt') || url.includes("chatpro.ai"))
  ) {
    return url;
  }
  return "javascript:void(0)";
}

const checkRestrictPlan = (auth, url) => {
  if(isPro(auth)) {
    if(url.includes('chatpdf') && auth.plan_restriction && auth.plan_restriction.includes('chatpdf')) {
      return true;
    }
  }
  return false;
}
const setPPG = (ppg) => {
  SetCookie('ppg', ppg, { path: '/' });
  SetCookie('ppg', ppg, { domain: '.ai-pro.org', path: '/' });
}

const setPMT = (pmt) => {
  SetCookie('pmt', pmt, { path: '/' });
  SetCookie('pmt', pmt, { domain: '.ai-pro.org', path: '/' });
};

const setLocales = (locales) => {
  SetCookie('locales', locales, { path: '/' });
  SetCookie('locales', locales, { domain: '.ai-pro.org', path: '/' });
};

export const getLocales = () => {
  // Check if URL has locales parameter
  const urlParams = new URLSearchParams(window.location.search);
  const localesParam = urlParams.get('locales');
  
  // Check existing cookie value if no URL parameter
  const existingCookie = GetCookie('locales');
  
  // Use URL param first, then cookie, then default to 'en'
  const localeValue = localesParam !== null ? localesParam : (existingCookie || 'en');
  
  // Set the cookie
  setLocales(localeValue);
  
  return localeValue;
}

export const redirectApp = async(auth, url) => {
  if(returnAppHref(auth, url) === url) return;
  // for unpaid user
  if(url.includes('create-art')
  || url.includes('dream-photo')
  || url.includes('text-to-image')
  || url.includes('chatgpt')
  || url.includes('chatbot')
  || url.includes("chatpro.ai")) {
    SetCookie('app', 'basic', { domain: '.ai-pro.org', path: '/' });
  } else {
    SetCookie('app', 'pro', { domain: '.ai-pro.org', path: '/' });
  }

  const cta_url = auth.status !== 'pending' && auth.expired === 'no' ? window.baseURL + 'upgrade' : window.baseURL + 'pricing';
  const DEFAULT_PPG = process.env.REACT_APP_DEFAULT_PPG ? process.env.REACT_APP_DEFAULT_PPG : "14";

  if(auth && cta_url === window.baseURL + 'pricing') {
    const currency = auth.currency.toLowerCase();
    if(currency === 'gbp'){
      setPPG('24');
      setPMT('st');
    }else if(currency === 'eur'){
      setPPG('26');
      setPMT('st');
    }else if(currency === 'brl'){
      setPPG('28');
      setPMT('st');
    }else if(currency === 'sar'){
      setPPG('30');
      setPMT('st');
    }else if(currency === 'aed'){
      setPPG('32');
      setPMT('st');
    }else if(currency === 'pln'){
      setPPG('73');
      setPMT('st');
    }else if(currency === 'ron'){
      setPPG('76');
      setPMT('st');
    }else if(currency === 'czk'){
      setPPG('79');
      setPMT('st');
    }else if(currency === 'huf'){
      setPPG('82');
      setPMT('st');
    }else if(currency === 'dkk'){
      setPPG('85');
      setPMT('st');
    }else if(currency === 'bgn'){
      setPPG('88');
      setPMT('st');
    }else{
      setPPG(DEFAULT_PPG);
    }
  }
  if(checkRestrictPlan(auth, url)) {
    SetCookie('app', 'promax', { domain: '.ai-pro.org', path: '/' });
    document.querySelectorAll("#modal-container .plan-name").forEach((item)=>{ item.textContent = 'PRO MAX'; });
  } else {
    document.querySelectorAll("#modal-container .plan-name").forEach((item)=>{ item.textContent = 'PRO'; });
  }

  if(checkRestrictPlan(auth, url)) {
    SetCookie('app', 'promax', { domain: '.ai-pro.org', path: '/' });
    document.querySelectorAll("#modal-container .plan-name").forEach((item)=>{ item.textContent = 'PRO MAX'; });
  } else {
    document.querySelectorAll("#modal-container .plan-name").forEach((item)=>{ item.textContent = 'PRO'; });
  }

  if(url.includes('chatgpt')) {
    document.querySelector("#modal-container .app-name").textContent = 'Chatbot+';
  } else if(url.includes('chat.ai') || url.includes('chatbot') || url.includes('start-chatbot')) {
    document.querySelector("#modal-container .app-name").textContent = 'ChatGPT';
  } else if(url.includes('chatpro.ai')) {
    document.querySelector("#modal-container .app-name").textContent = 'ChatGPTPro';
  } else if(url.includes('chatpdf')) {
    document.querySelector("#modal-container .app-name").textContent = 'ChatPDF';
  } else if(url.includes('convert-to-proper-english')) {
    document.querySelector("#modal-container .app-name").textContent = 'Grammar AI';
  } else if(url.includes('chatlibrary')) {
    document.querySelector("#modal-container .app-name").textContent = 'Prompt Library';
  } else if(url.includes('teacher')) {
    document.querySelector("#modal-container .app-name").textContent = 'TeacherAI';
  } else if(url.includes('search')) {
    document.querySelector("#modal-container .app-name").textContent = 'SearchAI';
  } else if(url.includes('create-art') || url.includes('dream-photo') || url.includes('text-to-image')) {
    document.querySelector("#modal-container .app-name").textContent = 'DreamPhoto';
  } else if(url.includes('interior')) {
    document.querySelector("#modal-container .app-name").textContent = 'Interior AI';
  } else if(url.includes('restorephoto')) {
    document.querySelector("#modal-container .app-name").textContent = 'Restore Photo';
  } else if(url.includes('clearbg')) {
    document.querySelector("#modal-container .app-name").textContent = 'Remove Background';
  } else if(url.includes('avatarmaker')) {
    document.querySelector("#modal-container .app-name").textContent = 'Avatar Maker';
  } else if(url.includes('storybook')) {
    document.querySelector("#modal-container .app-name").textContent = 'StoryBook';
  } else if(url.includes('multillm')) {
    document.querySelector("#modal-container .app-name").textContent = 'Multi-Chat';
  } else if(url.includes('sitebot')) {
    document.querySelector("#modal-container .app-name").textContent = 'SiteBot';
  } else if(url.includes('coding')) {
    document.querySelector("#modal-container .app-name").textContent = 'Coding AI';
  } else if(url.includes('flux')) {
    document.querySelector("#modal-container .app-name").textContent = 'Flux ImageGen';
  } else if(url.includes('tutor')) {
    document.querySelector("#modal-container .app-name").textContent = 'Homework Help';
  }
  document.querySelector("#modal-container .app-total").textContent  = totalApps;
  await axios.post(`${process.env.REACT_APP_API_URL}/click-app-upgrade`, { url }, { headers: { 'content-type': 'application/x-www-form-urlencoded' } });
  SetCookie('appurl', url, { domain: '.ai-pro.org', path: '/' });
  if (auth.plan==='enterprise'){
    document.getElementById("modal-container-enterprise").style.display = 'block';
  }else{
    document.querySelector('#modal-container #modal-cta').setAttribute('href', cta_url);
    document.getElementById("modal-container").style.display = 'block';
  }
};